<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    group
                </mat-icon>
                <span>
                    Group: {{ itemEnvelope?.Document?.Item?.Name }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit Group: {{ itemEnvelope?.Document?.Item?.GroupId }} - {{ itemEnvelope?.Document?.Item?.Name }}
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <div class="flex-direction-horizontal">
                    <div class="flex-container-basic">
                        <app-image srcPath="{{ avatarUrl }}" isApiImage="true" className="app-image-medium app-image-circle"></app-image>
                        <button *ngIf="itemEnvelope?.ItemId" mat-button class="button-mini button-inconspicuous avatar-button" (click)="editAvatar()">
                            <mat-icon class="material-symbols-outlined">
                                edit
                            </mat-icon>
                            EDIT
                        </button>
                    </div>
                    <div class="flex-direction-vertical flex-container-basic">
                        <mat-form-field appearance="outline">
                            <mat-label>Name</mat-label>
                            <input *ngIf="itemEnvelope" matInput name="Name" placeholder="Name" [(ngModel)]="$any(itemEnvelope).Document.Item.Name" />
                        </mat-form-field>
                    </div>
                </div>
            </form>
            <mat-tab-group>
                <br />
                <mat-tab label="General">
                    <br />
                    <form>
                        <span class="{{ dynamicClassNamePersonsSpan }}">
                            <app-chip-selector #personSelector idLinkPath="resource" label="People" className="width-medium-narrow" [isMultiSelect]="false" [availableItems]="availablePersons" [selectedItemIds]="selectedPersonIds"></app-chip-selector>
                        </span>
                        &nbsp;
                        &nbsp;
                        <button mat-button (click)="addPersonToGroup()" [disabled]="dynamicClassNamePersonsSpan == 'expanding-span-expanded' && this.selectedPersonIds.length == 0">
                            <mat-icon class="material-symbols-outlined" matTooltip="{{ dynamicClassNamePersonsSpan == 'expanding-span-expanded' && this.selectedPersonIds.length == 0 ? 'Enter a person name to enable this button' : '' }}">
                                {{ dynamicClassNamePersonsSpan == 'expanding-span-expanded' && this.selectedPersonIds.length == 0 ? 'warning' : 'add' }}
                            </mat-icon>
                            ADD PERSON
                        </button>
                        <button mat-button *ngIf="dynamicClassNamePersonsSpan == 'expanding-span-expanded'" (click)="cancelAddPersonToGroup()">
                            <mat-icon class="material-symbols-outlined">
                                cancel
                            </mat-icon>
                            CANCEL
                        </button>
                        <br />
                        <table mat-table *ngIf="itemEnvelope" [dataSource]="groupPersonsDatasource" class="mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let groupPerson">
                                    <app-image srcPath="{{ getPersonAvatarBlobPath(groupPerson.PersonId) }}" isApiImage="true" class="margin-wide-right nudge-down-small" className="app-image-extra-small app-image-circle"></app-image>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="FirstName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>First</th>
                                <td mat-cell *matCellDef="let groupPerson">{{ getPerson(groupPerson.PersonId)?.FirstName }}</td>
                            </ng-container>
                            <ng-container matColumnDef="LastName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>Last</th>
                                <td mat-cell *matCellDef="let groupPerson">{{ getPerson(groupPerson.PersonId)?.LastName }}</td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let groupPerson">
                                    <mat-icon class="material-symbols-outlined" (click)="deletePerson(groupPerson)">
                                        delete
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedGroupPersonColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedGroupPersonColumns"></tr>
                        </table>
                    </form>
                </mat-tab>
                <mat-tab label="Organizations">
                    <br />
                    <form>
                        <app-chip-selector #organizationalUnitsChipSelector label="OrganizationalUnits" className="width-medium-narrow" [isMultiSelect]="true" [availableItems]="availableOrganizationalUnits" [value]="selectedOrganizationalUnitIds"></app-chip-selector>
                    </form>
                </mat-tab>
                <mat-tab *ngIf="!isRevisionMode" label="History">
                    <div class="history-container">
                        <div class="history-container-section">
                            <app-history #appHistory *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope" [itemService]="this.itemService"></app-history>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>


